import React, { useEffect, useState } from 'react';
import { Button, Card, Space, Table, TablePaginationConfig } from 'antd';
import api from '@services/api';
import { Rescues } from '@services/types';
import { FormOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Navigation } from '@constants/Navigation';
import { useHistory } from 'react-router-dom';

const { Column } = Table;
const Rescue = () => {
  const history = useHistory();
  const [rescue, setRescue] = useState<Rescues[]>();
  const [pagination, setPagination] = React.useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    total: rescue?.length,
  });
  useEffect(() => {
    api.rescue.getRescue().then((data) => {
      setRescue(data);
    });
  }, []);

  const handleTableChange = React.useCallback((newPagination: TablePaginationConfig) => {
    setPagination(newPagination);
  }, []);
  return (
    <Card
      title="Rescue"
      extra={
        <Button type="primary" onClick={() => history.push(Navigation.CreateRescue)}>
          Add
        </Button>
      }
      bodyStyle={{ padding: 0 }}
    >
      <Table
        dataSource={rescue}
        onChange={handleTableChange}
        pagination={pagination}
        rowKey={(record: Rescues) => record.deviceType!}
      >
        <Column title="Device Type" dataIndex="deviceType" key="deviceType" />
        <Column title="Hardware ID" dataIndex="hwId" key="hwId" />
        <Column title="Usage ID" dataIndex="usId" key="usId" />
        <Column title="Description" dataIndex="description" />
        <Column
          title="Actions"
          key="action"
          render={(text, rescue: Rescues) => (
            <Space size="middle">
              <InfoCircleOutlined
                onClick={() => history.push(Navigation.RescueInfo.replace(':id', rescue?.id || ''))}
              />
              <FormOutlined onClick={() => history.push(Navigation.UpdateRescue.replace(':id', rescue?.id || ''))} />
            </Space>
          )}
        />
      </Table>
    </Card>
  );
};

export default React.memo(Rescue);
